// โลโก้แบรนด์ที่คนคนหนึ่งเข้าถึงได้ — ต่อท้ายชื่อในรายชื่อพนักงาน
//
// ตอบคำถามที่หน้า Staff เดิมตอบไม่ได้ถ้าไม่เปิดแผงทีละคน: ใครเข้าถึงกลุ่มไหนได้บ้าง
// รูปโลโก้อ่านเร็วกว่าชื่อเป็นข้อความ เพราะคนในเอเจนซีจำแบรนด์จากโลโก้อยู่แล้ว
//
// โลโก้ที่แสดงเรียงตามชื่อแบรนด์ ไม่ใช่ตามลำดับที่บันทึกสิทธิ์ — คนเดียวกันจึงเห็น
// ลำดับเดิมทุกครั้ง และเทียบข้ามแถวได้ว่าใครได้กลุ่มเดียวกัน
import type { Brand } from "@contracts/api";
import { ProductLogo } from "./product-logo";

/** เกินจากนี้ยุบเป็น +n — แถวยาวเกินไปจะเบียดชื่อคนซึ่งเป็นของหลักในแถว */
const MAX_LOGOS = 6;

export function AccessLogos({
  brandIds,
  byId,
}: {
  brandIds: string[];
  /** แบรนด์ที่เปิด My Job ไว้ — id ที่ไม่อยู่ในนี้คือกลุ่มที่ถูกปิดไปแล้ว ไม่ต้องแสดง */
  byId: Map<string, Brand>;
}) {
  const brands = brandIds
    .map((id) => byId.get(id))
    .filter((b): b is Brand => !!b)
    .sort((a, b) => a.name.localeCompare(b.name, "th"));

  if (!brands.length) return <span className="staff-brands staff-brands-none">—</span>;

  const shown = brands.slice(0, MAX_LOGOS);
  const rest = brands.slice(MAX_LOGOS);

  return (
    // title รวมทุกชื่อไว้ที่กล่อง ไม่ใช่ทีละรูป — ชี้ที่ไหนก็อ่านได้ครบว่ามีกลุ่มอะไร
    <span className="staff-brands" title={brands.map((b) => b.name).join(" · ")}>
      {shown.map((b) => (
        <ProductLogo key={b.id} url={b.logoUrl} letter={b.name.charAt(0)} size="xs" />
      ))}
      {!!rest.length && <span className="staff-brands-more">+{rest.length}</span>}
    </span>
  );
}
